import { makeStyles } from '@material-ui/core'
import AddIcon from '@mui/icons-material/Add'
import { ReactComponent as HeatmapNoDataLogo } from '../../../../components/1elements/Icons/svg/heatMap/heatmapNoDataLogo.svg'

const HMapTabNoData = ({title}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <HeatmapNoDataLogo/>
      <div className={classes.title}>No {title} Heatmaps to Display</div>
      <div className={classes.subTitles}>
        <div className={classes.subTitle}>To create a heatmap please use <AddIcon/> icon</div>
        <div className={classes.subTitle}>in the right corner</div>
      </div>
    </div>
  )
}

export default HMapTabNoData

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    padding: '15px 0',
    ...theme.typography.h1,
    color: theme.palette.tertiary.main
  },
  subTitles: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  subTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    ...theme.typography.p,
    color: theme.palette.tertiary.main,
    textAlign: 'center',
    lineHeight: 1.5
  }
}))
